import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import useDataStore from '@/services/dataStore/useDataStore'
import { BaseRemedySchema, IBaseRemedy } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetRemedies = (includeDeprecated = false) => {
  const {
    dataStore,
    dataStoreSWRVKey,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function fetchRemedies(dataStore: IDataStore): Promise<IBaseRemedy[]> {
    try {
      const response = await dataStore.getRemedies()

      const validation = z.array(BaseRemedySchema).safeParse(response)
      let remedies: IBaseRemedy[] = validation.data ?? []
      if (!validation.success) {
        remedies = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return remedies.filter(
        (remedy) => includeDeprecated || !remedy.deprecated
      )
    } catch (e) {
      handleDataStoreError(e)
      return []
    }
  }

  const result = useSWRV(
    () =>
      `/remedies/${dataStoreSWRVKey.value.perspective}?deprecated=${includeDeprecated}`,
    async () => {
      return await fetchRemedies(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000
    }
  )
  return result
}

export { useGetRemedies }
